const productMenuItems = [
  {
    to: '/products/whatsapp-crm/',
    label: 'WhatsApp CRM',
  },
  {
    to: '/products/school-management/',
    label: 'School Management',
  },
  {
    to: '/products/medical-wholesale-retail-app/',
    label: 'Medical Wholesale & Retail App',
  },
];

export const flattenProductMenuItems = (items = productMenuItems) =>
  items.flatMap((item) => [item, ...(item.children || [])]);

export default productMenuItems;
